import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
export function setKeysToFalseExceptKey(object, key) {
  return Object.keys(object).reduce((acc, property) => {
    if (property === key) acc[property] = object[property];else acc[property] = false;
    return acc;
  }, {});
}